export default {
    filters: {
        convertLatLng({ latitude, longitude }) {
            return { lat: latitude, lng: longitude };
        },
    },
};
